export interface UserResult {
  userId: string;
  displayName: string;
  createdAt: string;
}

export interface CreateUserRequest {
  displayName: string;
}

export async function createUser(request: CreateUserRequest) {
  const response = await fetch("/api/users", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(request),
  });

  if (!response.ok) {
    throw new Error(`User request failed with ${response.status}`);
  }

  return response.json() as Promise<UserResult>;
}
